<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">经验配置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="addBanner">新增等级</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column  prop="od" label="等级" ></el-table-column>
        <el-table-column  prop="gradename" label="等级名称" ></el-table-column>
        <el-table-column  prop="expvalue" label="所需经验值" ></el-table-column>
        <el-table-column  prop="rewards" label="奖励约豆" ></el-table-column>
        <el-table-column  prop="abgpic" label="A面勋章" >
            <template slot-scope="scope" align="center">
                <el-image
                style="width: 200px; height: 100px"
                class="img_inner"
                :src="scope.row.abgpic"
                fit="fit"></el-image>
            </template>
        </el-table-column>
        <el-table-column  prop="bbgpic" label="B面勋章" >
            <template slot-scope="scope" align="center">
                <el-image
                style="width: 200px; height: 100px"
                class="img_inner"
                :src="scope.row.bbgpic"
                fit="fit"></el-image>
            </template>
        </el-table-column>
        <el-table-column  prop="bgcolor" label="背景色" ></el-table-column>
        <el-table-column  prop="sliderbgcolor" label="进度条背景颜色" ></el-table-column>
        <el-table-column  prop="slidercolor" label="进度条颜色" ></el-table-column>
        <el-table-column  prop="fontcolor" label="字体颜色" ></el-table-column>
        <el-table-column align="center" label="操作">
            <template slot-scope="scope">
            <el-button size="mini" v-preventReClick type="danger" @click="delInfomercial(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" v-preventReClick type="primary" @click="editClick(scope.row)">修改</el-button>
            </template>
        </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="等级名称" prop="gradename">
                <el-input size="small" v-model="editForm.gradename" auto-complete="off" placeholder="等级名称"></el-input>
                </el-form-item>
                <el-form-item label="" prop="expvalue">
                    <el-input placeholder="请输入"  v-model="editForm.expvalue">
                        <template slot="append">经验</template>
                        <template slot="prepend">累计</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="rewards">
                    <el-input placeholder="请输入"  v-model="editForm.rewards">
                        <template slot="append">约豆</template>
                        <template slot="prepend">奖励</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="A面勋章" prop="abgpic">
                    <el-image
                    style="width: 200px; height: 100px"
                    class="img_inner"
                    v-if="editForm.abgpic != ''"
                    :src="editForm.abgpic"
                    fit="fit"></el-image>
                    <el-upload
                        :http-request="HandleChange"
                        :file-list="FileList"
                        accept=".jpg , .png ,"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="B面勋章" prop="bbgpic">
                    <el-image
                    style="width: 200px; height: 100px"
                    class="img_inner"
                    v-if="editForm.bbgpic != ''"
                    :src="editForm.bbgpic"
                    fit="fit"></el-image>
                    <el-upload
                        :http-request="HandleChange2"
                        :file-list="FileList2"
                        accept=".jpg , .png ,"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="背景色" prop="bgcolor">
                <el-input size="small" v-model="editForm.bgcolor" auto-complete="off" placeholder="游戏名称"></el-input>
                </el-form-item>
                <el-form-item label="进度条背景颜色" prop="sliderbgcolor">
                <el-input size="small" v-model="editForm.sliderbgcolor" auto-complete="off" placeholder="游戏名称"></el-input>
                </el-form-item>
                <el-form-item label="进度条颜色" prop="slidercolor">
                <el-input size="small" v-model="editForm.slidercolor" auto-complete="off" placeholder="游戏名称"></el-input>
                </el-form-item>
                <el-form-item label="字体颜色" prop="fontcolor">
                <el-input size="small" v-model="editForm.fontcolor" auto-complete="off" placeholder="游戏名称"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 视频 -->
        <el-dialog :visible.sync="videoFlag" width="45%" @click="closeDialog">
            <VideoPlay
                v-show="true"
                :videoUrl="videoUrl"
                :videoCover="videoCover"
                width="100%"
                :height="450"
                :autoplay="true"
                :controls="true"
                :loop="false"
                :muted="false"
                preload="auto"
                :showPlay="true"
                :playWidth="96"
                zoom="cotain"
            />
        </el-dialog>
</div>
</template>
<script>
import VideoPlay from '../video.vue'
import Pagination from '../../components/Pagination'
import { pgmlevelAdd , pgmlevelList , pgmlevelDel , pgmlevelUpdate } from '../../api/userMG'
export default {
    data(){
        return{
            maxexp:'',
            typeNum:'',
            videoFlag:false,
            videoUrl:'',
            rules: {
                gradename : [
                { required: true, message: '请输入等级名称', trigger: 'blur' }
                ],
                abgpic : [
                { required: true, message: '请输入A面勋章', trigger: 'blur' }
                ],
                bbgpic : [
                { required: true, message: '请输入B面勋章', trigger: 'blur' }
                ],
                bgcolor : [
                { required: true, message: '请输入背景颜色', trigger: 'blur' }
                ],
                sliderbgcolor : [
                { required: true, message: '请输入进度条背景颜色', trigger: 'blur' }
                ],
                slidercolor : [
                { required: true, message: '请输入进度条颜色', trigger: 'blur' }
                ],
                fontcolor : [
                { required: true, message: '请输入字体颜色', trigger: 'blur' }
                ],

                expvalue : [
                    { required: true, message: '请输入经验值', trigger: 'blur' },
                    {
                        pattern:  /^[+]{0,1}(\d+)$/,
                        required: true,
                        message: '请输入正确经验值',
                        trigger: 'blur'
                    }
                ],
                rewards : [
                    { required: true, message: '请输入奖励约豆', trigger: 'blur' },
                    {
                        pattern:  /^[+]{0,1}(\d+)$/,
                        required: true,
                        message: '请输入正确约豆值',
                        trigger: 'blur'
                    }
                ],
            },
            editSubForm:{},
            editFlag:false,
            FileList:[],
            FileList2:[],
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            options2:[{
                value: 1,
                label: '图片'
                }, {
                value: 2,
                label: '视频'
                },],
            editForm:{
                abgpic: "",
                bbgpic: "",
                bgcolor: "",
                expvalue: '',
                fontcolor: "",
                gradename:"",
                rewards: '',
                sliderbgcolor:"",
                slidercolor: "",
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        Pagination,
        VideoPlay
    },
    created(){
        this.getdata()
        this.gmpsettingQ()
    },
    methods:{
        editClick(row){
            this.editFlag = true
            this.editForm = JSON.parse(JSON.stringify(row))
            this.editFormVisible = true
        },
        gmpsettingQ(){
            gmpsettingQ().then(res=>{
                this.maxexp = res.data.maxexp
                this.maxexpId = res.data.id
            })
        },  
        maxexpSubmit(){
            let ms = /^\+?[1-9][0-9]*$/
            if(!ms.test(this.maxexp)){
                this.$message.error('请输入正确经验值')
            }else {
                gmpsettingUpload({
                    id:this.maxexpId,
                    maxexp:this.maxexp
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('修改成功')
                    }
                })
            }
        },  
        videoClick(row){
                this.videoUrl = row
                this.videoFlag = true
        },  
        // 新建提交
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if(this.editFlag){
                        pgmlevelUpdate(this.editForm).then(AddRes=>{
                            if(!AddRes.success){
                                this.$message.error(AddRes.message)
                            }else {
                                this.$message.success('添加成功')
                                this.getdata()
                                this.editFormVisible = false
                                this.videoFileList = []
                                this.editForm = {
                                    
                                }
                            }
                        })
                    }else {
                        pgmlevelAdd(this.editForm).then(AddRes=>{
                            if(!AddRes.success){
                                this.$message.error(AddRes.message)
                            }else {
                                this.$message.success('添加成功')
                                this.getdata()
                                this.editFormVisible = false
                                this.videoFileList = []
                                this.editForm = {
                                    
                                }
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },
        // 删除
        delInfomercial(index , row){
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                pgmlevelDel(row.id).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        handleChange(file){
            console.log(file)
            this.fileList = [file.file] 
            console.log(this.fileList)
        },
        HandleChange(file){
            console.log(file)
            this.FileList = [file.file]
            let formData = new FormData()
            formData.append('file' ,file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.editForm.abgpic = res.data.data
                this.FileList = []
            })
        },
        HandleChange2(file){
            console.log(file)
            this.FileList2 = [file.file]
            let formData = new FormData()
            formData.append('file' ,file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.editForm.bbgpic = res.data.data
                this.FileList2 = []
            })
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFlag = false
            this.editFormVisible = true
            this.fileList = []
            this.videoFileList = []
            this.editForm = {
                abgpic: "",
                bbgpic: "",
                bgcolor: "",
                expvalue: '',
                fontcolor: "",
                gradename:"",
                rewards: '',
                sliderbgcolor:"",
                slidercolor: "",
            }
        },
        getdata(){
            pgmlevelList().then(res=>{
                this.listData = res.data
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .img_inner{
    transform: all .3s;
    cursor: pointer;
  }
  .img_inner:hover{
    transform: scale(1.2);
  }
</style>


// WEBPACK FOOTER //
// src/views/system/grade.vue